import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { UIFullScreenLoader } from "components/UI/Loader";
import { redirectToLogout } from "actions/authActions";

export const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      onMount: redirectToLogout
    },
    dispatch
  );
};

const LogoutContainer = connect(
  null,
  mapDispatchToProps
)(UIFullScreenLoader);

export default LogoutContainer;
